import React, { useEffect, useState } from 'react';
import { ControllerStateAndHelpers } from 'downshift';
import { history, parseSearchQueryString } from 'react-hawksearch';
import { Product } from './models/index';
import { CustomSuggestionListProps } from './models/CustomSuggestionList';
import SearchBoxBasePreview from './SearchBoxBasePreview';

/**
 * This component is the search input box (with autosuggest) that should be utilized on search pages. For a simple
 * search input box that is meant to be used on non-search pages (or globally), see `GlobalSearchBox`.
 */

interface SearchBoxPreviewProps {
	SuggestionList?: React.ComponentType<CustomSuggestionListProps>;
}

function SearchBoxPreview({ SuggestionList }: SearchBoxPreviewProps) {
	// const { store, actor } = useHawksearch();
	const [initialKeyword, setInitialKeyword] = useState<string>('');

	useEffect(() => {
		const objs = parseSearchQueryString(location.search);
		setInitialKeyword(objs.Keyword);
	}, []);

	function handleSubmit(event: React.KeyboardEvent<HTMLInputElement>, downshift: ControllerStateAndHelpers<Product>) {
		if (event.key === 'Enter') {
			if (location.pathname.indexOf('search') !== -1) {
				history.push({
					search: `?keyword=${event.currentTarget.value}`,
				});
			} else {
				// redirect if it's not on search page
				window.location.href = `/search?keyword=${encodeURIComponent(event.currentTarget.value)}`;
			}
		}
	}

	// On Select view all matches from suggestion list
	function handleViewAllMatches(downshift: ControllerStateAndHelpers<Product>) {
		const { inputValue, closeMenu } = downshift;
		history.push({
			search: `?keyword=${inputValue}`,
		});
		closeMenu();
	}

	return (
		<div className="hawk__searchBox">
			<SearchBoxBasePreview
				onViewMatches={handleViewAllMatches}
				initialValue={initialKeyword}
				onSubmit={handleSubmit}
				SuggestionList={SuggestionList}
			/>
		</div>
	);
}

export default SearchBoxPreview;
